import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.min.js";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import ImpersonationBanner from './components/SuperAdmin/ImpersonationBanner';
import { ImpersonationProvider } from './contexts/ImpersonationContext';
import setupAxios from './middlewares/setupAxios';
import reportWebVitals from './reportWebVitals';
import { authCallbacks, store } from './store';

setupAxios(authCallbacks)

const render = () => {
  const App = require('./pages/App').default

  const root = createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <Provider store={store}>
      <BrowserRouter>        
        <React.StrictMode>
          <ImpersonationProvider>
            <ImpersonationBanner />
            <App />
          </ImpersonationProvider>
        </React.StrictMode>
      </BrowserRouter>
    </Provider>
  )
}

render()

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./pages/App', render)
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
